import React from 'react'
import CollectionTags from '../../common/CollectionTags'

import { useDispatch } from 'react-redux'

import { CLEAR_FILTER_FIELDS } from '../../../redux_toolkit/@types/action.types'
import { useNavigate } from 'react-router-dom'
import { FilterActionTypes } from '../../../redux_toolkit/V3/Filter'
import { getBreadCrumbs, setBreadCrumbRoutes } from '../../../helpers/Util'
import Image from '../../../common/Image'

const SingleItemCollection = ({ collections }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const renderCollectionPhotos = (photos) => {
        return photos?.slice(0, 7)?.map((item) => {
            return (
                <Image
                    key={`photo_${item.id}`}
                    src={item.docUrl}
                    alt='style'
                    isStatic={false}
                />
            )
        })
    }

    const handleRoute = (collection) => {
        dispatch(FilterActionTypes[CLEAR_FILTER_FIELDS]())
        let newRoute = `/collections/${collection.id}`
        let visitingRoutes = getBreadCrumbs()
        visitingRoutes.push({
            key: newRoute,
            value: collection.name
        })

        setBreadCrumbRoutes(visitingRoutes)
        navigate(newRoute)
    }

    const renderCollections = () => {
        return collections?.map((item) => {
            return (
                <div
                    className={`collection-single-row-item mb-6 4xl:mb-10 ${
                        item?.coverDocumentResponse?.docUrl ? 'cover-photo' : ''
                    }`}
                    key={`collection_card_one_${item.id}`}
                    onClick={(e) => {
                        e.stopPropagation()
                        handleRoute(item)
                    }}
                >
                    <div className='collection-content'>
                        <div className='collection-status'>
                            <CollectionTags item={item} />
                        </div>
                        <h3 className='collection-title'>{item.name}</h3>
                        <div className='details-info'>
                            <ul className='common-list-component'>
                                {item?.season && <li>{item?.season}</li>}
                                {item?.numOfDesign && (
                                    <li>
                                        {item.numOfDesign}{' '}
                                        {item.numOfDesign > 1
                                            ? 'Styles'
                                            : 'Style'}
                                    </li>
                                )}
                                {item?.ownerName && <li>{item.ownerName}</li>}
                            </ul>
                        </div>
                    </div>
                    <div className='collection-photos'>
                        {!item?.coverDocumentResponse?.docUrl &&
                            renderCollectionPhotos(item.documentResponseList)}
                        {item?.coverDocumentResponse?.docUrl && (
                            <Image
                                key={`photo_${item.id}`}
                                src={item?.coverDocumentResponse?.docUrl}
                                alt='style'
                                isStatic={false}
                            />
                        )}
                    </div>
                </div>
            )
        })
    }

    return <>{renderCollections()}</>
}

export default SingleItemCollection
